import Vue from 'vue';
import VSelect from 'vue-select';

Vue.component('v-select', VSelect);
